export type PaymentProvider =
	| 'stripe'
	| 'invoice'
	| 'stripe_subscriptions'
	| 'stripe_invoicing'
	| 'internal_trial'
	| 'internal_billing';
export const paymentProviderValues: PaymentProvider[] = [
	'stripe',
	'stripe_subscriptions',
	'stripe_invoicing',
	'internal_trial',
	'internal_billing',
] as const;
